var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageLayout',{attrs:{"title":"Creer un Prospect"},scopedSlots:_vm._u([{key:"breadcrumb",fn:function({}){return [_c('div',[_vm._v("Meilleure Copro - Ajout d'un prospect")])]}}])},[_c('ProspectFastForm',{ref:"form",attrs:{"version":"mco"},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }